import { Flex, Paper, Text, Title, Divider } from "@mantine/core";
import { EditIcon } from "../../shared/svg";
import "./Profile.scss";
import useProfileStore from "../../store/useProfileStore";
import useAuthStore from "../../store/useAuthStore";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const Skills = () => {
  const { profile } = useProfileStore();
  const { cvProcessing } = useAuthStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const skills = profile?.skills || [];

  const hardSkills = skills.filter((skill) => skill.type === "hard_skill");
  const softSkills = skills.filter((skill) => skill.type === "soft_skill");

  const PROFICIENCY_OPTIONS = [
    { value: "not_specified", label: t("not_specified") },
    { value: "beginner", label: t("beginner") },
    { value: "intermediate", label: t("intermediate") },
    { value: "advanced", label: t("advanced") },
    { value: "expert", label: t("expert") },
  ];

  const getProficiencyLabel = (value: string): string | undefined => {
    const option = PROFICIENCY_OPTIONS.find((opt) => opt.value === value);
    return option?.label;
  };

  return (
    <Paper withBorder radius="24px" p={32} h="100%" pos="relative">
      <div
        className="edit-icon"
        onClick={() => navigate("/profile/edit/skills")}
      >
        <EditIcon />
      </div>
      <Title size={36} lh="50px">
        {t("skills")}
      </Title>

      {skills.length > 0 ? (
        <>
          {hardSkills.length > 0 && (
            <>
              <Divider
                label={
                  <Text fz={18} fw={500}>
                    {t("hard_skills")}
                  </Text>
                }
                labelPosition="center"
                mt={30}
                mb={16}
              />
              <Flex wrap="wrap" gap={8}>
                {hardSkills.map((skill) => (
                  <Paper
                    key={skill.id}
                    px={18}
                    py={8}
                    style={{
                      maxWidth: "100%",
                    }}
                    withBorder
                    radius={25}
                  >
                    <Text
                      fw={500}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {skill.skill_name}
                    </Text>
                    {skill.proficiency && (
                      <Text size="xs" color="dimmed">
                        {getProficiencyLabel(skill.proficiency)}
                      </Text>
                    )}
                  </Paper>
                ))}
              </Flex>
            </>
          )}

          {softSkills.length > 0 && (
            <>
              <Divider
                label={
                  <Text fz={18} fw={500}>
                    {t("soft_skills")}
                  </Text>
                }
                labelPosition="center"
                mt={30}
                mb={16}
              />
              <Flex wrap="wrap" gap={8}>
                {softSkills.map((skill) => (
                  <Paper
                    key={skill.id}
                    px={18}
                    py={8}
                    style={{
                      maxWidth: "100%",
                    }}
                    withBorder
                    radius={25}
                  >
                    <Text
                      fw={500}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {skill.skill_name}
                    </Text>
                    {skill.proficiency && (
                      <Text size="xs" color="dimmed">
                        {getProficiencyLabel(skill.proficiency)}
                      </Text>
                    )}
                  </Paper>
                ))}
              </Flex>
            </>
          )}
        </>
      ) : (
        <Text c="#737373" mt={30}>
          {cvProcessing !== "processing" ? t("no_skills") : t("no_skills_cv")}
        </Text>
      )}
    </Paper>
  );
};
